var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98438 1.98645C6.7195 1.99059 6.46709 2.09957 6.28254 2.28949C6.09799 2.4794 5.99637 2.73472 6 2.99942V3.99873H5C3.90694 3.99873 3 4.90505 3 5.99736V19.9877C3 21.08 3.90694 21.9863 5 21.9863H19C20.0931 21.9863 21 21.08 21 19.9877V5.99736C21 4.90505 20.0931 3.99873 19 3.99873H18V2.99942C18.0018 2.86573 17.9768 2.73302 17.9264 2.60917C17.876 2.48531 17.8012 2.37282 17.7065 2.27837C17.6118 2.18391 17.4991 2.10941 17.375 2.05926C17.251 2.00912 17.1182 1.98436 16.9844 1.98645C16.7195 1.99059 16.4671 2.09957 16.2825 2.28949C16.098 2.4794 15.9964 2.73472 16 2.99942V3.99873H8V2.99942C8.00183 2.86573 7.9768 2.73302 7.92638 2.60917C7.87597 2.48531 7.80119 2.37282 7.70649 2.27837C7.61179 2.18391 7.49908 2.10941 7.37504 2.05926C7.25101 2.00912 7.11816 1.98436 6.98438 1.98645ZM5 8.99529H19V19.9877H5V8.99529ZM13 12.9925C12.448 12.9925 12 13.4402 12 13.9918V16.9898C12 17.5414 12.448 17.9891 13 17.9891H16C16.552 17.9891 17 17.5414 17 16.9898V13.9918C17 13.4402 16.552 12.9925 16 12.9925H13Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventManage);
export default __webpack_public_path__ + "static/media/Event Manage.d56dcc5ba356ffcb8efaa7d89e58da8b.svg";
export { ForwardRef as ReactComponent };